import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

const rawBackendUrl = process.env.REACT_APP_BACKEND_URL;

if (!rawBackendUrl) {
  throw new Error("REACT_APP_BACKEND_URL is not set");
}

const trimmedBackendUrl = rawBackendUrl.endsWith("/")
  ? rawBackendUrl.slice(0, -1)
  : rawBackendUrl;

// API_BASE_URL should include /api prefix for Kubernetes ingress routing and /v1 for backend routes
export const API_BASE_URL = `${trimmedBackendUrl}/api/v1`;

// Socket.IO base URL — namespace is appended, path option controls the HTTP endpoint
export const SOCKET_IO_URL = trimmedBackendUrl;

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
